module.exports = __webpack_public_path__ + "static/media/fundamental.9e669cbe.jpg";